import '../CsvJsonInfoPages.scss';


function Models() {

    const data = [
        { field: 1, description: 'Model Code (Int)' },
        { field: 2, description: 'Model Description (Char)' },
        { field: 3, description: 'Range Code (Int)' },
        { field: 4, description: 'Manufacturer Code (Int)' },
        { field: 5, description: 'Order Number (Int)' },
        { field: 6, description: 'Year first derivative in Model was Introduced (Int)' },
        { field: 7, description: 'Year last derivative in Model was Discontinued (Blank if current) (Int)' },
        { field: 8, description: 'Body Style found in NVDBodyStyle table (Int)' },
    ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Models</h1>
            <p>Provides a list of Models coded by CAP.<br /><br/>
                CAP Vehicles are split into the following sections:<br /><br />
                Manufacturer e.g. FORD<br />
                Model Range e.g. MONDEO<br />

                <b>Model e.g. MONDEO SALOON</b><br />
                Derivative e.g. ZETEC 4DR<br />

                Trim e.g. ZETEC
            </p>

            <b>File Naming Convention</b><br />
            <p>The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_CAPMod.txt<br />
                LIGHTS_yyyy-mm-dd_CAPMod.txt<br />
                HEAVIES_yyyy-mm-dd_CAPMod.txt<br />
                BIKES_yyyy-mm-dd_CAPMod.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
           
        </div>
    );
}

export default Models;
